export default "__VITE_ASSET__BINC4f6G__"